import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PendoTag from '../tag/pendo-tag.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import { PendoLoading } from '../../directives/loading/pendo-loading.js';
import { PendoAnalytics } from '../../directives/analytics/pendo-analytics.js';
import { lineClamp } from '../../utils/line-clamp.js';
import { hasSlot } from '../../utils/utils.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _empty() {}
function _invokeIgnored(body) {
  var result = body();
  if (result && result.then) {
    return result.then(_empty);
  }
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  name: 'PendoMediaCard',
  components: {
    PendoTag
  },
  directives: {
    PendoAnalytics,
    PendoTooltip,
    PendoLoading
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      default: () => []
    },
    shadow: {
      type: String,
      default: 'never',
      validator: shadow => ['always', 'hover', 'never'].includes(shadow)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    overlayProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      titleTooltipContent: null,
      subtitleTooltipContent: null,
      isHovering: false
    };
  },
  computed: {
    showOverlay() {
      if (this.disabled) {
        return false;
      }
      const {
        trigger,
        show
      } = _objectSpread2({
        trigger: 'hover',
        show: false
      }, this.overlayProps);
      if (trigger === 'hover' && this.isHovering) {
        return true;
      }
      if (trigger === 'hover' && !this.isHovering) {
        return !!show;
      }
      return trigger === 'manual' && !!show;
    },
    shadowType() {
      return this.disabled ? 'never' : this.shadow;
    },
    isInteractive() {
      return !this.disabled && hasSlot(this, 'overlay');
    }
  },
  watch: {
    title() {
      this.checkTitleOverflow();
    },
    loading: _async(function () {
      const _this = this;
      return _invokeIgnored(function () {
        if (!_this.loading) {
          return _await(_this.$nextTick(), function () {
            _this.checkTitleOverflow();
            _this.checkSubtitleOverflow();
          });
        }
      });
    })
  },
  mounted: _async(function () {
    const _this2 = this;
    return _await(_this2.$nextTick(), function () {
      if (!_this2.loading) {
        _this2.checkTitleOverflow();
        _this2.checkSubtitleOverflow();
      }
    });
  }),
  methods: {
    onMouseenter(event) {
      this.isHovering = true;
      this.$emit('mouseenter', event);
    },
    onMouseleave(event) {
      this.isHovering = false;
      this.$emit('mouseleave', event);
    },
    checkTitleOverflow: _async(function () {
      const _this3 = this;
      const hasCustomTitleSlotContent = hasSlot(_this3, 'title');
      if (hasCustomTitleSlotContent) {
        return;
      }
      const {
        title
      } = _this3.$refs;
      return _invokeIgnored(function () {
        if (title) {
          return _await(lineClamp({
            element: _this3.$refs.title,
            lineCount: 2
          }), function (isClamped) {
            _this3.titleTooltipContent = isClamped ? _this3.title : null;
          });
        }
      });
    }),
    checkSubtitleOverflow: _async(function () {
      const _this4 = this;
      const hasCustomSubtitleSlotContent = hasSlot(_this4, 'subtitle');
      if (hasCustomSubtitleSlotContent) {
        return;
      }
      const {
        subtitle
      } = _this4.$refs;
      if (subtitle && subtitle.offsetWidth < subtitle.scrollWidth) {
        _this4.subtitleTooltipContent = _this4.subtitle;
      }
      return _await();
    })
  }
};

export { script as default };
//# sourceMappingURL=pendo-media-card.vue2.js.map
